import React from "react";
import { Props } from "./types";

function BulletListIcon({ className }: Props) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="16"
      height="16"
    >
      <circle cx="4" cy="7" r="1.5" fill="currentColor" stroke="none" />
      <circle cx="4" cy="12" r="1.5" fill="currentColor" stroke="none" />
      <circle cx="4" cy="17" r="1.5" fill="currentColor" stroke="none" />
      <line x1="8" y1="7" x2="21" y2="7" />
      <line x1="8" y1="12" x2="21" y2="12" />
      <line x1="8" y1="17" x2="21" y2="17" />
    </svg>
  );
}

export { BulletListIcon };
